module.exports = __webpack_public_path__ + "img/icon-010.7a1fd26d.png";